module.exports = __webpack_public_path__ + "img/no-data.215bc5e8.png";